<template>
  <div style="margin-bottom:15px;">
    <a-button size="normal"
              @click="refreshData">刷新</a-button>
    <a-button size="normal"
              @click="addAssociationRole">添加关联用户</a-button>
    <a-popconfirm title="是否确定删除选中的关联用户"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="deleteConfirm">
      <a-button :disabled="selectedRow.length > 0 ? false : true"
                size="normal">删除关联</a-button>
    </a-popconfirm>
  </div>
  <a-table :data-source="dataSource"
           :columns="columns"
           :custom-row="customRowFn"
           :loading="loading"
           :row-selection="{ selectedRowKeys: selectedRow, type: 'checkbox', onChange: onSelectChange }">
    <template #bodyCell="{ column, text, record }">
      <template v-if="column.dataIndex === 'name'">
        <div class="editable-cell">
          <div class="editable-cell-text-wrapper">
            {{ text }}
          </div>
        </div>
      </template>
      <template v-else-if="column.dataIndex === 'operation'">
        <a @click="deleteAssociationRoleRow(record)">删除关联</a>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="deleteAssociationRoleVisible"
           title="删除"
           :confirm-loading="confirmLoading"
           @ok="deleteRoleConfirm">
    <p style="font-size:16px">是否删除关联用户：<span style="color:red">{{ deleteAssociationRoleForm.name }}</span></p>
  </a-modal>
  <a-modal v-model:visible="addAssociationRoleVisible"
           title="添加关联用户"
           width="140vh"
           @ok="addAssociationRoleConfirm">
    <!-- <a-table :dataSource="dataSource" :columns="columns"></a-table> -->
    <splitpanes class="default-theme splitPanesMain"
                :push-other-panes="false">
      <pane size='70'
            min-size="0"
            max-size="55">
        <a-card title="列表">
          <a-table :scroll="{ y: 270 }"
                   :data-source="adddataSource"
                   :columns="addColumns"
                   :custom-row="addCustomRowFn"
                   :row-selection="{ selectedRowKeys: addselectedRow, onChange: addOnSelectChange, type: 'checkbox' }">
          </a-table>
        </a-card>
      </pane>
      <pane size='30'
            min-size="40"
            max-size="55"
            style="overflow:auto">
        <a-card :title='"已选" + addSelectedArray.length + "条"'>
          <template #extra>
            <a v-if="addSelectedArray.length"
               herf="#"
               @click="deleteAllSelected">清空</a>
          </template>
          <div>
            <a-tag v-for="item in addSelectedArray"
                   :key="item.key"
                   closable
                   @close="deleteRow(item)">{{
                     item.username
                   }}
            </a-tag>
          </div>
        </a-card>
      </pane>
    </splitpanes>
  </a-modal>
</template>

<script setup lang="ts">
import { message } from 'ant-design-vue'
import { remove, assign, findIndex } from 'lodash'
import { Pane, Splitpanes } from 'splitpanes'
import { reactive, ref, watch } from 'vue'
import { useRbacStore } from '../../DefaultRbacPagePlugin'

const rbac = useRbacStore()
// 表层操作逻辑
// 定义table column数据类型
type UserFormState = {
  name: string,
  email: string,
  key: string
}
//  定义基础数据
const loading = ref<boolean>(false)
const confirmLoading = ref<boolean>(false)
const dataSource: Array<UserFormState> = reactive([])

// 监听模块
watch(
  () => rbac.$state.models.role, () => {
    remove(selectedRow)
  },
  { deep: true }
)
/** -------监听模块 End ------------- */

// 业务模块
// 【业务模块】-[按钮]-[刷新] refresh(刷新表格数据)
const refreshData = () => {
  loading.value = true
  remove(selectedRow)
  setInterval(() => {
    loading.value = false
  }, 1500)
}

//  【业务模块】-[按钮]-[添加关联角色]  addAssociationRole(打开关联角色Modal)
const addAssociationRole = () => {
  addAssociationRoleVisible.value = true
  remove(addSelectedArray)
  remove(addselectedRow)
}

//  【业务模块】-[按钮]-[删除关联]-Modal-confirm (删除关联 对话确认框确认方法)
const deleteConfirm = () => {
  selectedRow.forEach(item => {
    dataSource.forEach((el, index) => {
      if (item === el.key) {
        dataSource.splice(index, 1)
      }
    })
  })
}

// 【表格模块】
// 【表格模块】-[表格行]-rowClick(选中表格单挑数据)
const customRowFn = (record: UserFormState) => {
  return {
    onclick: () => {
      // 判断是否已勾选中此条数据
      if (!selectedRow.find(item => item == record.key)) {
        selectedRow.push(record.key)
      } else {
        selectedRow.forEach((item, index) => {
          if (item == record.key) {
            selectedRow.splice(index, 1)
          }
        })
      }
    }
  }
}

// 【表格模块】-[多选框]-checkboxClick(选中多选框)
const onSelectChange = (keys: Array<string>) => {
  remove(selectedRow)
  selectedRow.push(...keys)
}

// 【表格模块】-[操作列]-[删除关联]-Modal (打开删除关联Modal)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const deleteAssociationRoleRow = (rowData: any) => {
  assign(deleteAssociationRoleForm, rowData)
  deleteAssociationRoleVisible.value = true
}

// 【表格模块】-[操作列]-[删除关联]-Modal-Confirm(删除关联Modal 确认方法)
const deleteRoleConfirm = () => {
  const { key } = deleteAssociationRoleForm
  confirmLoading.value = true
  const currentIndex = findIndex(dataSource, (item) => item.key == key)
  dataSource.splice(currentIndex, 1)
  setTimeout(() => {
    deleteAssociationRoleVisible.value = false
    confirmLoading.value = false
    message.success('删除成功')
  }, 200)
}

// 添加关联角色模块(modal)
//  定义table columns数据类型
type addUserFormState = {
  loginname: string,
  username: string,
  associationTime: string,
  key: string
}
//  定义基础数据
const selectedRow: Array<string> = reactive([])
const addSelectedArray: Array<addUserFormState> = reactive([])
const addselectedRow: Array<string> = reactive([])
const deleteAssociationRoleVisible = ref<boolean>(false)
const addAssociationRoleVisible = ref<boolean>(false)
const adddataSource: Array<addUserFormState> = reactive([])
const deleteAssociationRoleForm = reactive<UserFormState>({
  name: '',
  email: '',
  key: ''
})
// 【模块管理】
// 【模块管理】-Modal-Confirm（确认）
const addAssociationRoleConfirm = () => {
  addAssociationRoleVisible.value = false
  message.success('添加成功！')
}
// 【模块管理】-[表格]-rowClick(选中单条数据)
const addCustomRowFn = (record: addUserFormState) => {
  return {
    onclick: () => {
      // 判断是否已勾选中此条数据
      if (!addselectedRow.find(item => item == record.key)) {
        addselectedRow.push(record.key)
        addSelectedArray.push(record)
      } else {
        addselectedRow.forEach((item, index) => {
          if (item == record.key) {
            addselectedRow.splice(index, 1)
            addSelectedArray.splice(index, 1)
          }
        })
      }
    }
  }
}
//  【模块管理】-[表格]-checkboxClick(选中多选框)
const addOnSelectChange = (keys: Array<string>) => {
  remove(addselectedRow)
  addselectedRow.push(...keys)
}
/** -------表格操作 End ------------- */


//  【模块管理】-[右侧操作模块]-deleteSingleData(删除单条已选择的数据)
const deleteRow = (item: addUserFormState) => {
  remove(addSelectedArray, (el) => el.key == item.key)
  remove(addselectedRow, (el) => el == item.key)
}

//  【模块管理】-[右侧操作模块]-deleteAllData(删除所有已选择的数据)
const deleteAllSelected = () => {
  remove(addSelectedArray)
  remove(addselectedRow)
}

//* * -------模块管理 End -------------*/

const columns = ref([
  {
    title: '用户名',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    key: 'age',
  },
  {
    title: '关联时间',
    dataIndex: 'createtime',
    key: 'createtime',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

const addColumns = ref([
  {
    title: '登录名',
    dataIndex: 'loginname',
    key: 'loginname'
  }, {
    title: "用户名",
    dataIndex: 'username',
    key: 'username'
  }, {
    title: "关联时间",
    dataIndex: 'associationTime',
    key: 'associationTime'
  }
])
</script>

<style lang="less" scoped>
.splitPanesMain {
  height: 60vh;
}

:deep(.splitpanes__splitter) {
  background-color: #95808017 !important;
}

:deep(.splitpanes__pane) {
  background-color: #f5f5f529 !important;
}

:deep(.ant-tag) {
  width: 100%;
}

:deep(.ant-tag:not(:first-child)) {
  margin-top: 20px;
}
</style>
